import Icon from '../components/Icon';

const Calendar = Icon(
  'calendar',
  <>
    <path
      fillRule="evenodd"
      d="M17.25 2.25a.75.75 0 0 0-1.5 0V3h-7.5v-.75a.75.75 0 0 0-1.5 0V3h-1.5A2.25 2.25 0 0 0 3 5.25v13.5A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V5.25A2.25 2.25 0 0 0 18.75 3h-1.5zM19.5 7.5V5.25a.75.75 0 0 0-.75-.75h-1.5v.75a.75.75 0 0 1-1.5 0V4.5h-7.5v.75a.75.75 0 0 1-1.5 0V4.5h-1.5a.75.75 0 0 0-.75.75V7.5zM4.5 9h15v9.75a.75.75 0 0 1-.75.75H5.25a.75.75 0 0 1-.75-.75z"
      clipRule="evenodd"
    />
  </>
);

export default Calendar;
